import React from "react";
import {Icon, Tooltip} from "@material-ui/core";
import {primaryDropColor} from "../../ScreenBar";

export const DragHandle = ({type}) => {
    return (
        <div
            style={{
                background: '#cccccc',
                display: 'flex',
                justifyContent: 'center',
                position: 'absolute',
                right: 0,
                top: 0,
                zIndex: 9999,
                cursor: 'move'
            }}
        >
            <Tooltip title={`Move ${type}`}>
                <Icon fontSize={"small"} style={{
                    fontSize: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    color: primaryDropColor
                }}>
                    zoom_out_map
                </Icon>
            </Tooltip>
        </div>
    )
};